module.exports = __webpack_public_path__ + "img/txjg_img_en.77161ae3.png";